import React, {useState, useEffect} from 'react';
import {
    CardBody, CardTitle, Col,
    FormGroup,
    Input, Label,
    Row,
} from 'reactstrap';
import {INTERNATIONAL, YES_CONTINUE} from "../../../components/i18n/i18n";
import VectorInputLangs from "./vectorInputLangs";
import {FL_ICON, FL_INVERTED_ICON, FL_WEIGHT} from "../../../components/i18n/formLabels";

export default function VectorInput(props) {
    const [weight, setWeight]               = useState(props.selectedEdge.handleText !== undefined ? props.selectedEdge.handleText : 0);
    const [icon, setIcon]                   = useState(props.selectedEdge.icon !== undefined ? props.selectedEdge.icon : '');
    const [invertedIcon, setInvertedIcon]   = useState(props.selectedEdge.invertedIcon !== undefined ? props.selectedEdge.invertedIcon : '');

    const [ vector, setVector ] = useState(props.selectedEdge.handleText !== undefined ? props.selectedEdge : {});
    const [ langs, setLangs ] = useState(props.selectedEdge.langs !== undefined ? props.selectedEdge.langs : []);
    const [ editMode ] = useState(props.selectedEdge.handleText !== undefined );

    useEffect( () => {
    },[] );

    const onClick = () => {
        if (props.selectedEdge.handleText === undefined) {
            props.onNewEdge( props.sourceViewNode, props.targetViewNode, weight, langs)
            props.onClose()
        } else {
            let _edge = props.selectedEdge
            _edge.handleText = weight
            _edge.icon = icon
            _edge.invertedIcon = invertedIcon
            _edge.langs = langs
            props.onEditEdge( _edge )
            props.onClose()
        }
    }

    return (
        <div className='custom-ui-form'>
            <CardBody className="">
                <h1>{'Información del camino'}</h1>
                <Row>
                    <Col md="6">
                        <FormGroup>
                            <Label>{ FL_WEIGHT }</Label>
                            <Input
                                type="number"
                                name="weight"
                                min="0"
                                value={weight}
                                onChange={e => setWeight(e.target.value)}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label>{ FL_ICON }</Label>
                            <Input
                                type="text"
                                name="icon"
                                value={icon}
                                onChange={e => setIcon(e.target.value)}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label>{ FL_INVERTED_ICON }</Label>
                            <Input
                                type="text"
                                name="invertedIcon"
                                value={invertedIcon}
                                onChange={e => setInvertedIcon(e.target.value)}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="fas fa-language mr-2"/>
                    { INTERNATIONAL }
                </CardTitle>
                <CardBody>
                    <VectorInputLangs
                        editMode={editMode}
                        disableInputs={false}
                        vector={vector}
                        langs={langs}
                        setLangs={(_langs) => {setLangs(_langs)}}
                    />
                </CardBody>
                <button className="btn-alert-delete" onClick={onClick} >
                    { YES_CONTINUE }
                </button>
            </CardBody>
        </div>
    )
}